import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { PopoverDirective } from 'ngx-bootstrap/popover';
@Component({
  selector: 'app-info-tooltip',
  templateUrl: './info-tooltip.component.html',
  styleUrls: ['./info-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoTooltipComponent implements OnDestroy {
  private static nextId = 0;

  /**
   * Unique id for the popover text, referenced by the trigger's
   * aria-describedby while the popover is open so screen readers announce the
   * revealed message (ngx-bootstrap's popover adds no such association itself).
   */
  readonly popoverTextId = `app-info-tooltip-text-${InfoTooltipComponent.nextId++}`;

  /** Message shown in the popover body. Pass it already translated. */
  @Input() text = '';

  @Input() heading?: string;
  @Input() icon = 'fa-info';

  /**
   * Accessible label for the trigger button. Falls back to a translated
   * "More information" in the template when not provided.
   */
  @Input() ariaLabel?: string;

  @ViewChild(PopoverDirective) private popover?: PopoverDirective;

  private readonly hideOnScroll = () => this.popover?.hide();

  onShown(): void {
    document.addEventListener('scroll', this.hideOnScroll, true);
  }

  onHidden(): void {
    document.removeEventListener('scroll', this.hideOnScroll, true);
  }

  ngOnDestroy(): void {
    document.removeEventListener('scroll', this.hideOnScroll, true);
  }
}
